export default "__VITE_ASSET__$m3_lPxg__"